'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.guid = exports.randomElement = exports.getClosestPair = exports.dist = exports.xprod = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
/* injects from baggage-loader */

exports.toCamelCase = toCamelCase;
exports.toSnakeCase = toSnakeCase;
exports.prependZeroes = prependZeroes;
exports.parsePhone = parsePhone;
exports.unparsePhone = unparsePhone;
exports.areDatesEqualUpToPrecision = areDatesEqualUpToPrecision;
exports.areDatesFullPeriod = areDatesFullPeriod;
exports.capitalizeWords = capitalizeWords;
exports.interpolateLinear = interpolateLinear;
exports.padNumber = padNumber;
exports.getPairs = getPairs;
exports.minimum = minimum;
exports.maximum = maximum;
exports.numberWithSpaces = numberWithSpaces;

var _lodash = require('lodash');

var _snakeCase = require('snake-case');

var _snakeCase2 = _interopRequireDefault(_snakeCase);

var _camelCase = require('camel-case');

var _camelCase2 = _interopRequireDefault(_camelCase);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _curry = require('curry');

var _curry2 = _interopRequireDefault(_curry);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function changeCase(obj, transform) {
  if ((0, _lodash.isArray)(obj)) {
    return obj.map(function (x) {
      return changeCase(x, transform);
    });
  } else if ((0, _lodash.isObject)(obj)) {
    return (0, _lodash.mapValues)((0, _lodash.mapKeys)(obj, function (v, k) {
      return transform(k);
    }), function (x) {
      return changeCase(x, transform);
    });
  }
  return obj;
}

function toCamelCase(obj) {
  return changeCase(obj, _camelCase2.default);
}

function toSnakeCase(obj) {
  return changeCase(obj, _snakeCase2.default);
}

function prependZeroes(value, length) {
  var zeroes = '';
  for (var i = 0; i < length; i++) {
    zeroes += '0';
  }
  return (zeroes + value).slice(-length);
}

function parsePhone(phone) {
  return phone ? phone.replace('+7', '').replace(/\s+/g, '') : '';
}

function unparsePhone(phone) {
  return phone ? '+7 ' + phone.slice(0, 3) + ' ' + phone.slice(3, 6) + ' ' + phone.slice(6, 8) + ' ' + phone.slice(8, 10) : '';
}

function areDatesEqualUpToPrecision(d1, d2) {
  var precision = arguments.length <= 2 || arguments[2] === undefined ? 'day' : arguments[2];

  var nd1 = (0, _moment2.default)(d1).startOf(precision);
  var nd2 = (0, _moment2.default)(d2).startOf(precision);

  return nd1.diff(nd2) === 0;
}

function areDatesFullPeriod(_ref) {
  var start = _ref.start;
  var end = _ref.end;
  var _ref$period = _ref.period;
  var period = _ref$period === undefined ? 'month' : _ref$period;
  var _ref$precision = _ref.precision;
  var precision = _ref$precision === undefined ? 'day' : _ref$precision;

  var mStart = (0, _moment2.default)(start);
  var mEnd = (0, _moment2.default)(end);

  var mStartOf = (0, _moment2.default)(mStart).startOf(period);
  var mEndOf = (0, _moment2.default)(mEnd).endOf(period);

  var numberOfPeriods = Math.ceil(mEndOf.diff(mStartOf, period, true));

  return numberOfPeriods === 1 && areDatesEqualUpToPrecision(mStart, mStartOf, precision) && areDatesEqualUpToPrecision(mEnd, mEndOf, precision);
}

function capitalizeWords(s) {
  return s.replace(/(?:^|\s)\S/g, function (a) {
    return a.toUpperCase();
  });
}

// ==================== //
// =       MATH       = //
// ==================== //

function interpolateLinear(_ref2) {
  var a = _ref2.a;
  var b = _ref2.b;
  var c = _ref2.c;
  var d = _ref2.d;
  var x = _ref2.x;

  if (b - a < 10e-30) {
    return c + d / 2;
  } // a being equal to b leads to undefined results

  var relative = (x - a) / (b - a);
  return relative * (d - c) + c;
}

function padNumber(_ref3) {
  var _ref3$min = _ref3.min;
  var min = _ref3$min === undefined ? -Infinity : _ref3$min;
  var _ref3$max = _ref3.max;
  var max = _ref3$max === undefined ? Infinity : _ref3$max;
  var x = _ref3.x;

  if (x < min) {
    return min;
  }
  if (x > max) {
    return max;
  }

  return x;
}

// getPairs([1,2,3]) -> [[1, 2], [2, 3]]
// getPairs([1,2,3], true) -> [[1, 2], [2, 3], [3, undefined]]
function getPairs(array) {
  var includeLast = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];

  var zipped = (0, _lodash.zip)(array, (0, _lodash.drop)(array));
  return includeLast ? zipped : (0, _lodash.dropRight)(zipped);
}

function minimum(arr) {
  return arr.reduce(function (a, b) {
    return Math.min(a, b);
  }, Infinity);
}

function maximum(arr) {
  return arr.reduce(function (a, b) {
    return Math.max(a, b);
  }, -Infinity);
}

function numberWithSpaces(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
}

// cartesian product of two lists
var xprod = exports.xprod = function xprod(a, b) {
  var idx = 0;
  var ilen = a.length;
  var j = undefined;
  var jlen = b.length;
  var result = [];
  while (idx < ilen) {
    j = 0;
    while (j < jlen) {
      result[result.length] = [a[idx], b[j]];
      j += 1;
    }
    idx += 1;
  }
  return result;
};

// distance between points
var dist = exports.dist = (0, _curry2.default)(function (a, b) {
  var dx = Math.abs(a.x - b.x);
  var dy = Math.abs(a.y - b.y);
  return Math.sqrt(dx * dx + dy * dy);
});

var getClosestPair = exports.getClosestPair = function getClosestPair(a, b) {
  var allPairs = xprod(a, b);
  var result = allPairs.reduce(function (_ref4, _ref5) {
    var minP1 = _ref4.minP1;
    var minP2 = _ref4.minP2;
    var minDist = _ref4.minDist;

    var _ref6 = _slicedToArray(_ref5, 2);

    var p1 = _ref6[0];
    var p2 = _ref6[1];

    var currDist = dist(p1, p2);
    return currDist < minDist ? { minP1: p1, minP2: p2, minDist: currDist } : { minP1: minP1, minP2: minP2, minDist: minDist };
  }, { minP1: {}, minP2: {}, minDist: Infinity });

  var p1 = result.minP1;
  var p2 = result.minP2;
  var minDist = result.minDist;


  return { p1: p1, p2: p2, dist: minDist };
};

var randomElement = exports.randomElement = function randomElement(array) {
  return array[Math.floor(Math.random() * array.length)];
};

var guid = exports.guid = function guid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0;
    var v = c === 'x' ? r : r & 0x3 | 0x8;
    return v.toString(16);
  });
};


//////////////////
// WEBPACK FOOTER
// ./app/utils/utils.js
// module id = 68
// module chunks = 1